import customNode from './node/index';


export default {
  nodes: customNode,
  props: {
    superClass: ["bpmn:FlowNode"]
  }

}